
<template>
  <!-- Footer -->
  <div class='card'>
    <div class='heading text-center'>
      <div class='head1'>Why go with us</div>
      <p class='bdr'></p>
    </div>
    <div class='card-body'>
      <div class='row m-0 pt-5'>
        <div class='card col-12 col-md-3'>
          <div class='card-content'>
            <i class='fa fa-hands-helping fa-3x'></i>
            <div class='card-title'>Reliability</div>
            <p>
              <small
                >We are committed to having every aspect of our offer at maximum
                level and to being there for you whenever it takes</small
              >
            </p>
            <!-- <div class='learn-more'>
                            <p> <small> LEARN MORE <label><i class='fas fa-angle-right'></i></label> </small> </p>
                        </div> -->
          </div>
        </div>
        <div class='card col-12 col-md-2'>
          <div class='card-content'>
            <i class='fas fa-sync fa-3x'></i>
            <div class='card-title'>Flexibility</div>
            <p>
              <small
                >We won't miss any opportunity on the field which would make
                your stay complete and more interesting</small
              >
            </p>
            <!-- <div class='learn-more'>
                            <p> <small> LEARN MORE <label><i class='fas fa-angle-right'></i></label> </small> </p>
                        </div> -->
          </div>
        </div>
        <div class='card col-12 col-md-2'>
          <div class='card-content'>
            <i class='fas fa-palette fa-3x'></i>
            <div class='card-title'>Diverse offer</div>
            <p>
              <small
                >We take you to every corner of Montenegro and tell you the most
                diverse stories</small
              >
            </p>
            <!-- <div class='learn-more'>
                            <p> <small> LEARN MORE <label><i class='fas fa-angle-right'></i></label> </small> </p>
                        </div> -->
          </div>
        </div>
        <div class='card col-12 col-md-2'>
          <div class='card-content'>
            <i class='fas fa-binoculars fa-3x'></i>
            <div class='card-title'>Local expertise</div>
            <p><small>We know Montenegro like the back of our hands</small></p>
            <!-- <div class='learn-more'>
                            <p> <small> LEARN MORE <label><i class='fas fa-angle-right'></i></label> </small> </p>
                        </div> -->
          </div>
        </div>
        <div class='card col-12 col-md-3'>
          <div class='card-content'>
            <i class='fas fa-tree fa-3x'></i>
            <div class='card-title'>Eco friendly</div>
            <p>
              <small
                >We care about avoiding any negative effect on nature and
                contributing to environmental protection</small
              >
            </p>
            <!-- <div class='learn-more'>
                            <p> <small> LEARN MORE <label><i class='fas fa-angle-right'></i></label> </small> </p>
                        </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class='card-footer row m-0'>
      <div>
        <div class='row' style='height: 5vh'>
          <p>
            <label>
              <i class='fas fa-phone fa-rotate-90 text-primary'></i>
            </label>
            +382 67 264 762
          </p>
        </div>
        <div class='row' style='margin-top: 0px; padding-top: 0px'>
          <p>
            <label> <i class='fas fa-envelope text-primary'></i> </label>
            info@natourmontenegro.com
            <!-- <a href = 'mailto: info@natourmontenegro.com'>Send Email</a> -->
          </p>
        </div>
      </div>

      <div class=''>
        <p>
          <small class='follow-text'>FOLLOW US ON SOCIAL MEDIA</small>
          <label class='footer-right'>
            <a
              class='social-links'
              target='_blank'
              href='https://www.instagram.com/natourmontenegro/'
              ><i class='fab fa-instagram'></i>
            </a>
            <a
              class='social-links'
              target='_blank'
              href='https://www.facebook.com/Natour-Montenegro-Tours-Experiences-101466425389212'
              ><i class='fab fa-facebook'></i>
            </a>
            <a
              class="social-links"
              target="_blank"
              href="https://en.tripadvisor.com.hk/Attraction_Review-g304088-d23329111-Reviews-Natour_Montenegro_travel_agency-Podgorica_Podgorica_Municipality.html"
              ><i class="fab fa-tripadvisor"></i>
            </a>
            <!-- <a class='social-links' target='_blank' href='https://www.facebook.com/pages/Crna%20Gora/109828182370402/'><i class='fab fa-linkedin'></i> </a>
                     <a class='social-links' target='_blank' href='https://www.facebook.com/pages/Crna%20Gora/109828182370402/'><i class='fab fa-twitter'></i></a> -->
          </label>
        </p>
      </div>
    </div>
    <div class='card-content card-title projekat'>
      <p style='text-align:center'><small>This Project is co-financed by the European Union and the Government of Montenegro</small></p>
      <p style='text-align:center'><small>*The contents of this publication are the sole responsibility of Natour Montenegro and can in no way be taken to reflect the views of the European Union</small></p>
      <div class='row'>
        <div class='col-md-3' style='text-align:center'><img class='logo-biro' src='../assets/logo/eu-logo.png'/></div>
        <div class='col-md-3' style='text-align:center'><img class='logo-biro' src='../assets/logo/mne-logo.png'/></div>
        <div class='col-md-3' style='text-align:center'><img class='logo-biro' src='../assets/logo/zzzcg-logo.png'/></div>
        <div class='col-md-3' style='text-align:center'><img class='logo-biro' src='../assets/logo/zzcgeu2.jpg'/></div>
      </div>
    </div>
  </div>

  <!-- Footer -->
</template>

<script>
import { mdbFooter, mdbContainer, mdbRow, mdbCol } from 'mdbvue'
export default {
  name: 'Footer',
  components: {
    mdbFooter,
    mdbContainer,
    mdbRow,
    mdbCol
  }
}
</script>

<style scoped>
body {
  background-color: #616161;
}
.social-links {
  text-decoration: none;
  color: white;
}
.card {
  background-color: #616161;
  color: white;
  margin-top: 50px;
  border: none;
  border-radius: 0px;
}

.head1 {
  font-weight: 900;
  font-size: 30px;
}

.bdr {
  border-bottom: 1.5px solid #72ba6b;
  /* #FFB74D;*/
  width: 65px;
  margin-right: auto;
  margin-left: auto;
}

.card-footer {
  justify-content: space-between;
  border: none;
  background: none;
  /* border-bottom: 0.5px solid #9e9e9e; */
}

.footer-right > i {
  margin-left: 15px;
}

.fa-hand-holding-usd {
  color: #72ba6b;
}

.fa-handshake {
  color: #72ba6b;
}

.card-title {
  margin-bottom: 0.75rem;
  font-weight: 900;
  font-size: 15px;
  margin-top: 1.75rem;
}

.learn-more {
  color: #72ba6b;
}

.fa-angle-right {
  margin-left: 10px;
}

.fa-3x {
  color: #72ba6b;
}

.card-content {
  padding-right: 40px;
  padding-left: 30px;
  padding-bottom: 10px;
  padding-top: 10px;
}

.card-content > p {
  color: #9e9e9e;
}

.heading {
  position: relative;
  top: 75px;
}

.follow-text {
  color: #9e9e9e;
}
.projekat {
 background-color:rgba(51, 51, 50, 0.8);
 text-align:left;
 margin-top:0;
 margin-bottom:0;
 padding: 3vh 17vw 3vh 17vw;

}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue